import { useEffect, useState } from "react";
import axios from "axios";
import { PRODUCTS } from "../../data/mock";
import { ProductCard } from "./ProductCard";
import { CheckoutDialog } from "./CheckoutDialog";
import { SaleBanner } from "./SaleBanner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Products = () => {
  const [selected, setSelected] = useState(null);
  const [pkgData, setPkgData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/packages`).then((res) => setPkgData(res.data)).catch(() => {});
  }, []);

  const saleActive = !!pkgData?.sale?.active;
  const salePercent = saleActive ? Math.round((1 - pkgData.sale.discount) * 100) : 0;

  return (
    <section id="products" className="relative py-16 sm:py-24" data-testid="products-section">
      <div className="mx-auto max-w-6xl px-4">
        <h2 className="font-heading text-center text-3xl sm:text-4xl uppercase tracking-tight text-white mb-6">
          <span className="text-gradient-blue">Supplier</span> + Full Guide
        </h2>
        {saleActive && <SaleBanner endsAt={pkgData.sale.ends_at} percentOff={salePercent} />}
        <div className="mt-6 space-y-8">
          {PRODUCTS.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              pricing={pkgData?.[product.id]}
              saleActive={saleActive}
              salePercent={salePercent}
              onBuy={setSelected}
            />
          ))}
        </div>
      </div>
      {selected && (
        <CheckoutDialog
          key={selected.id}
          product={selected}
          pkgData={pkgData}
          onClose={() => setSelected(null)}
        />
      )}
    </section>
  );
};
